var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BudgetsActions } from '../../constants/actions';
import { isAnyAsyncActionOf, handleAsyncActions, } from '../../stores/redux/utils';
import { BFF_TEAM_ACCOUNT_BUDGETS_API_PATH, BFF_ADD_TEAM_ACCOUNT_BUDGET_API_PATH, BFF_UPDATE_TEAM_ACCOUNT_BUDGET_API_PATH, BFF_DELETE_BUDGET_API_PATH, BFF_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS_API_PATH, } from '../../constants/values';
import RequestHelper from '../../utils/request_helper';
export var initialState = {
    teamAccountBudgets: [],
    actionStatuses: {},
    teamAccountBudgetConfigurationOptions: {
        allowedOrderContents: [],
    },
};
export var fetchTeamAccountBudgets = createAsyncThunk(BudgetsActions.FETCH_TEAM_ACCOUNT_BUDGETS, function (_a, _b) {
    var teamAccountId = _a.teamAccountId, includeGroupsInfo = _a.includeGroupsInfo;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, RequestHelper.fetchCamelizedJSON(BFF_TEAM_ACCOUNT_BUDGETS_API_PATH, {
                            method: 'GET',
                            queryParams: {
                                teamAccountId: teamAccountId,
                                includeGroupsInfo: includeGroupsInfo,
                            },
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_1 = _c.sent();
                    return [2 /*return*/, rejectWithValue(e_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var addTeamAccountBudget = createAsyncThunk(BudgetsActions.ADD_TEAM_ACCOUNT_BUDGET, function (budgetObject, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var apiPath, response, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    apiPath = budgetObject.budgetId
                        ? BFF_UPDATE_TEAM_ACCOUNT_BUDGET_API_PATH
                        : BFF_ADD_TEAM_ACCOUNT_BUDGET_API_PATH;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, RequestHelper.fetchCamelizedJSON(apiPath, {
                            method: 'POST',
                            data: budgetObject,
                        })];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response];
                case 3:
                    e_2 = _b.sent();
                    return [2 /*return*/, rejectWithValue(e_2)];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export var deleteBudget = createAsyncThunk(BudgetsActions.DELETE_BUDGET, function (budgetId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, RequestHelper.fetchCamelizedJSON(BFF_DELETE_BUDGET_API_PATH, {
                            method: 'POST',
                            data: {
                                budgetId: budgetId,
                            },
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_3 = _b.sent();
                    return [2 /*return*/, rejectWithValue(e_3)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
export var fetchTeamAccountBudgetConfigurationOptions = createAsyncThunk(BudgetsActions.FETCH_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS, function (_a, _b) {
    var teamAccountId = _a.teamAccountId;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_4;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, RequestHelper.fetchCamelizedJSON(BFF_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS_API_PATH, {
                            method: 'GET',
                            queryParams: {
                                teamAccountId: teamAccountId,
                            },
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 2:
                    e_4 = _c.sent();
                    return [2 /*return*/, rejectWithValue(e_4)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
var budgetsSlice = createSlice({
    name: 'budgets',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchTeamAccountBudgets.fulfilled, function (state, action) {
            state.teamAccountBudgets = action.payload.teamAccountBudgets;
        })
            .addCase(fetchTeamAccountBudgetConfigurationOptions.fulfilled, function (state, action) {
            state.teamAccountBudgetConfigurationOptions =
                action.payload.budgetConfigurationOptions;
        })
            .addMatcher(isAnyAsyncActionOf(BudgetsActions.FETCH_TEAM_ACCOUNT_BUDGETS, BudgetsActions.DELETE_BUDGET, BudgetsActions.ADD_TEAM_ACCOUNT_BUDGET, BudgetsActions.FETCH_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS), handleAsyncActions);
    },
});
export default budgetsSlice.reducer;
